import React from 'react'
import "../CSS/Template/Footer.css"
import { Link } from "react-router-dom";

export default function footer() {
  return (
    <footer id='footerTag'>
      <Link to="/Terms-And-Conditions">Terms And Conditions</Link>
      <p>This Website Created By Arindam In 2022 &copy;</p>
      <Link to="/Privacy-Policy">Privacy Policy</Link>
    </footer>
  )
}
